import React from "react";
import { Link } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import { ArrowLeft, ShieldCheck } from "lucide-react";

export default function Privacy() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen flex flex-col bg-cream" data-testid="privacy-page">
      <Navbar />
      <main className="section flex-1">
        <div className="container-app max-w-3xl">
          <Link to="/" className="fx-btn fx-btn--ghost text-sm mb-4 inline-flex" data-testid="back-home">
            <ArrowLeft size={14} /> {t("common.backHome")}
          </Link>
          <div className="flex items-center gap-2 mb-2">
            <ShieldCheck className="text-hive-ink" />
            <h1 className="font-display text-4xl md:text-5xl font-extrabold text-worker">{t("legal.privacy.title")}</h1>
          </div>
          <p className="text-smoke">{t("legal.privacy.effective")}</p>

          <div className="card-base p-4 mt-6 bg-linen border-sand">
            <p className="text-sm text-worker"><Trans i18nKey="legal.draftBadge" components={{ strong: <strong />, em: <em /> }} /></p>
          </div>

          <section className="mt-8 space-y-6 text-worker">
            <Block title={t("legal.privacy.s1Title")}>
              <ul className="list-disc list-inside space-y-1 text-sm">
                {[1,2,3,4,5].map(n => (
                  <li key={n}><Trans i18nKey={`legal.privacy.s1l${n}`} components={{ strong: <strong /> }} /></li>
                ))}
              </ul>
            </Block>
            <Block title={t("legal.privacy.s2Title")}>
              <ul className="list-disc list-inside space-y-1 text-sm">
                {[1,2,3,4].map(n => (<li key={n}>{t(`legal.privacy.s2l${n}`)}</li>))}
              </ul>
            </Block>
            <Block title={t("legal.privacy.s3Title")}>
              <ul className="list-disc list-inside space-y-1 text-sm">
                {[1,2,3].map(n => (
                  <li key={n}><Trans i18nKey={`legal.privacy.s3l${n}`} components={{ strong: <strong /> }} /></li>
                ))}
              </ul>
              <p className="text-sm mt-2">{t("legal.privacy.s3Foot")}</p>
            </Block>
            <Block title={t("legal.privacy.s4Title")}>{t("legal.privacy.s4Body")}</Block>
            <Block title={t("legal.privacy.s5Title")}>{t("legal.privacy.s5Body")}</Block>
            <Block title={t("legal.privacy.s6Title")}>{t("legal.privacy.s6Body")}</Block>
            <Block title={t("legal.privacy.s7Title")}>
              <ul className="list-disc list-inside space-y-1 text-sm">
                {[1,2,3].map(n => (<li key={n}>{t(`legal.privacy.s7l${n}`)}</li>))}
              </ul>
            </Block>
            <Block title={t("legal.privacy.s8Title")}>{t("legal.privacy.s8Body")}</Block>
            <Block title={t("legal.privacy.s9Title")}>{t("legal.privacy.s9Body")}</Block>
            <Block title={t("legal.privacy.s10Title")}>{t("legal.privacy.s10Body")}</Block>
            <Block title={t("legal.privacy.s11Title")}>{t("legal.privacy.s11Body")}</Block>
            <Block title={t("legal.privacy.s12Title")}>
              <Trans
                i18nKey="legal.privacy.s12Body"
                components={{ a: <a className="text-hive-ink hover:underline" href="mailto:support@fixydany.com" /> }}
              />
            </Block>
            {/* What the provider does with the audio is the provider's policy to
                state, so this links to it rather than paraphrasing a retention
                period we do not control. What IS ours is stated exactly: the
                transcript is kept, the audio is not. */}
            <Block title={t("legal.privacy.s13Title")}>
              <Trans
                i18nKey="legal.privacy.s13Body"
                components={{ a: <a className="text-hive-ink hover:underline"
                  href="https://elevenlabs.io/privacy" target="_blank" rel="noreferrer" /> }}
              />
            </Block>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
}

function Block({ title, children }) {
  return (
    <div>
      <h2 className="font-display text-xl font-bold text-worker mb-1">{title}</h2>
      <div className="text-sm text-worker/90 leading-relaxed">{children}</div>
    </div>
  );
}
